import axios from "axios";
import { Quota } from "../types/quota";

export const QuotaTransport = {
    list: async (): Promise<Array<Quota> | Array<any>> => {
        const { data } = await axios.get<Array<Quota>>(`/quota`, {});
        return data.map((el, index) => ({ ...el, id: index }));
    },
};
